import { render, staticRenderFns } from "./ProductionFrontOverlayCard.vue?vue&type=template&id=070732f7&scoped=true&"
import script from "./ProductionFrontOverlayCard.vue?vue&type=script&lang=ts&"
export * from "./ProductionFrontOverlayCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionFrontOverlayCard.vue?vue&type=style&index=0&id=070732f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070732f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardText,VCardTitle})
